module.exports = __webpack_public_path__ + "img/logo_footer.3bbaed4.png";